import type { AcquisitionType } from '../../../support/acquisitionTypes';
import type { BannerRule } from './types';
import {
  zeroDownloadsRule,
  assetNotCoveredRule,
  batchZeroDownloadsRule,
} from './rules';

type BannerConfig = Partial<Record<AcquisitionType, BannerRule[]>>;

const bannerConfig: BannerConfig = {
  download: [assetNotCoveredRule],
  'batch-download': [batchZeroDownloadsRule],
  'subscription-download': [zeroDownloadsRule],
  'subscription-license': [zeroDownloadsRule, assetNotCoveredRule],
  'alacarte-license': [zeroDownloadsRule, assetNotCoveredRule],
};

export default bannerConfig;
